<template>
    <div>
        <el-button type="primary" @click="getCommodity">选择产品</el-button>
        <el-button type="danger" @click="batchDelete">批量删除</el-button>
        <el-table
            size="small"
            :data="multipleSelection"
            ref="tableRef"
            stripe
            border
            highlight-current-row
            style="max-width: 1450px;margin-top: 20px"
        >
            <el-table-column align="center" label width="180" type="selection"></el-table-column>
          <el-table-column align="center" label="id">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="标题">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="图标" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.icon" style="width: 80px; height: 80px; object-fit: cover" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="完成天数">
            <template slot-scope="scope">
              <span>{{ scope.row.completionDays }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="价格">
            <template slot-scope="scope">
              <span>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">下架</span>
              <span v-if="scope.row.status === 1">上架</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="推介指数">
            <template slot-scope="scope">
              <el-rate
                  v-model="scope.row.starLevel"
                  disabled
              >
              </el-rate>
            </template>
          </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="{ row,$index }">
                    <el-button type="danger" size="mini" @click="removeGoodsList(row,$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <product
            :visible.sync="dlGoodsShow"
            :select-list.sync="dialogGoodsList"
            @on-select="onSelect"
        ></product>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
import users from '../../components/users/index.vue'
import commodity from '@/components/commodity/shop.vue'
import product from '@/components/product/product.vue'
import { getSpuArr } from '@/api/demo/discount'
import { getProductList } from '@/api/merchant/service/product'
export default {
  name: 'selectGoods',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    users,
    product
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    goodsIds: {
      handler: function (val, oldVal) {
        this.getSearch()
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        this.goodsIds = [...val]
      },
      deep: true
    }
  },
  data () {
    return {
      goodsIds: [], // 商品id
      multipleSelection: [], // 商品数据
      dlGoodsShow: false,
      dialogGoodsList: [], // 弹窗商品列表
      listLoading: false
    }
  },
  created () {
    let that = this
  },
  mounted () {
    console.log(this.goodsIds, 'this.value')
    this.goodsIds = [...this.value]

    this.getSearch()
  },
  methods: {
    // 获取商品列表
    async getSearch () {
      if (this.goodsIds.length === 0) {
        this.multipleSelection = []
        return
      }
      let that = this
      that.listLoading = true
      let params = {
        page: 1,
        size: 1000,
        productIds: this.goodsIds
      }
      let res = await getProductList(params)
      that.listLoading = false
      that.multipleSelection = res.records
    },
    // 清空
    cancel (form) {
      this.$refs[form].resetFields()
    },
    // 选择商品
    getCommodity () {
      this.dlGoodsShow = true
      this.dialogGoodsList = this.multipleSelection // 勾选回选
    },
    // 商品弹窗确认选择
    async onSelect (data) {
      let that = this
      if (this.multipleSelection == '') {
        data.forEach(item => {
          this.multipleSelection.push({
            icon: item.icon,
            id: item.id,
            name: item.name,
            price: item.price,
            completionDays: item.completionDays,
            status: item.status,
            title: item.title,
            starLevel: item.starLevel
          })
        })
      } else {
        data.map(item => {
          this.multipleSelection.push({
            icon: item.icon,
            id: item.id,
            name: item.name,
            price: item.price,
            completionDays: item.completionDays,
            status: item.status,
            title: item.title,
            starLevel: item.starLevel
          })
        })
      }
      this.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (!obj[this.multipleSelection[i].id]) {
            result.push(this.multipleSelection[i])
            obj[this.multipleSelection[i].id] = true
          }
        }
        this.multipleSelection = result
        this.updateList()
      })
    },
    // 删除商品
    async removeGoodsList (row, index) {
      let that = this
      this.multipleSelection.splice(index, 1)
      this.updateList()
    },
    updateList () {
      let goodsIds = []
      this.multipleSelection.forEach(item => {
        goodsIds.push(item.id)
      })
      this.goodsIds = [...new Set(goodsIds)]
      this.$emit('update:value', this.goodsIds)
    },
    // 批量删除
    async batchDelete () {
      let that = this
      if (!that.$refs.tableRef.selection.length) {
        that.$message.error('请勾选要删除的产品')
        return
      }
      var seid = that.$refs.tableRef.selection
      let itmu = that.multipleSelection
      for (let i = 0; i < seid.length; i++) {
        for (let y = 0; y < itmu.length; y++) {
          if (JSON.stringify(itmu[y]) == JSON.stringify(seid[i])) {
            // 判断是否相等，相等就删除
            console.log(itmu[y])
            that.multipleSelection.splice(y, 1)
            // console.log(that.multipleSelection, "that.form.multipleSelection");
          }
        }
      }
      that.updateList()
    },
    // 有效时间
    dataSearch (e) {
      this.form.giftFailureTime = e
    }
  }
}
</script>
<style scope>
.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.margins {
    margin-bottom: 30px !important;
}
</style>
